export default __webpack_public_path__ + "static/media/close-booking.9469cedb.svg";